<template>
  <video-player
    ref="videoPlayer"
    class="video-player-box"
    :options="playerOptions[format]"
    :playsinline="true"
    custom-event-name="customstatechangedeventname"
    @play="onPlayerPlay($event)"
    @pause="onPlayerPause($event)"
    @ended="onPlayerEnded($event)"
    @canplay="onPlayerCanplay($event)"
    @statechanged="playerStateChanged($event)"
    @ready="playerReadied"
  />
</template>
<script>
import 'video.js/dist/video-js.css';
import { mapGetters } from 'vuex';

// noinspection ES6CheckImport
import { videoPlayer } from 'vue-video-player';
// videojs
// noinspection NpmUsedModulesInstalled
import videojs from 'video.js';

window.videojs = videojs;
// hls plugin for videojs6
require('videojs-contrib-hls/dist/videojs-contrib-hls.js');
export default {
  name: 'Player',
  components: {
    videoPlayer,
  },
  timers: {
    // Refresh connection every 9 minutes so it doesn't stay IDLE
    refreshWSConnection: { time: 540000, autostart: true, repeat: true },
    // Restart connection every 90 minutes to avoid APIGW dropping it
    restartWsConnection: { time: 5400000, autostart: true, repeat: true },
  },
  props: {
    language: {
      type: String,
      default: 'it',
    },
  },
  data: function () {
    return {
      format: '', //'mp4',
      playerOptions: {
        STREAM: {
          fill: true,
          // videojs and plugin options
          //preload:'auto',
          autoplay: true,
          responsive: true,
          sources: [
            {
              withCredentials: false,
              type: 'application/x-mpegURL',
              src: '',
            },
          ],
          controlBar: {
            timeDivider: false,
            durationDisplay: false,
          },
          flash: { hls: { withCredentials: false } },
          html5: { hls: { withCredentials: false } },
        },
        MP4: {
          fill: true,
          autoplay: true,
          sources: [
            {
              type: 'video/mp4',
              src: '',
            },
          ],
        },
      },
      connection: null,
    };
  },
  computed: {
    ...mapGetters(['streamUrl', 'videoOnDemandUrl', 'mode', 'wsUrl']),
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  mounted() {
    this.format = this.mode;
    this.playerOptions.STREAM.sources[0].src = this.streamUrl;
    this.playerOptions.MP4.sources[0].src = this.videoOnDemandUrl;

    this.connection = new WebSocket(this.wsUrl);
    this.connection.onopen = function () {
      console.log('Successfully connected to the echo websocket server');
    };
  },
  methods: {
    // listen event
    onPlayerPlay(player) {
      console.log('player play!', player);
    },
    onPlayerPause(player) {
      console.log('player pause!', player);
    },
    onPlayerEnded(player) {
      console.log('player pause!', player);
    },
    onPlayerCanplay(player) {
      console.log('player pause!', player);
    },
    // ...player event
    // or listen state event
    playerStateChanged(playerCurrentState) {
      console.log('player current update state', playerCurrentState);
    },

    // player is ready
    playerReadied(player) {
      console.log('the player is readied', player);
      // you can use it to do something...
      // player.[methods]
    },
    refreshWSConnection() {
      this.connection.send('PING');
    },
    restartWsConnection() {
      if(this.connection) {
        this.connection.close();
      }
      this.connection = new WebSocket(this.wsUrl);
    },
  },
};
</script>
<style>
</style>
